<div class="row">
<div class="col-md-12">
    <h2>Important Dates</h2>
    </div>
</div>
<app-home-card-config [contenttype]="'important_dates'"></app-home-card-config>
